"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMobileData = void 0;
var pay_api_1 = require("@l2p/pay-api");
var date_fns_1 = require("date-fns");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var CancelTranaction_1 = __importDefault(require("./CancelTranaction"));
var useMobileData = function (filteredData, revalidateTransactions) {
    var t = (0, next_intl_1.useTranslations)('translation');
    return (0, react_1.useMemo)(function () {
        return filteredData.map(function (item, idx) {
            var type = item.type, paymentMethod = item.paymentMethod, amount = item.amount, createdAt = item.createdAt, status = item.status, currency = item.currency, id = item.id;
            return {
                status: status,
                action: type === pay_api_1.TransactionTypeEnum.Withdrawal &&
                    status === pay_api_1.TransactionStatusEnum.Pending ? (react_1.default.createElement("div", { style: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    } },
                    react_1.default.createElement("span", null, t("".concat(type))),
                    react_1.default.createElement(CancelTranaction_1.default, { id: id, revalidateTransactions: revalidateTransactions }))) : (t("".concat(type))),
                paymentSystem: paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.replace(/_/g, ' '),
                amount: "".concat(amount, " ").concat(currency),
                date: (0, date_fns_1.format)(new Date(createdAt), 'HH:mm, dd-LL-yy'),
                idx: idx,
            };
        });
    }, [t, filteredData]);
};
exports.useMobileData = useMobileData;
